import {useState, useEffect} from 'react';
import {Link, useLocation} from 'react-router-dom';
import {motion, AnimatePresence} from 'framer-motion';
import './Header.css';

const Header = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        setIsMobileMenuOpen(false);
    }, [location]);

    const menuItems = [
        {path: '/', label: 'Home'},
        {path: '/about', label: 'About'},
        {path: '/architectural-work', label: 'Architectural'},
        {path: '/interior-work', label: 'Interior'},
        {path: '/contact', label: 'Contact'},
    ];

    return (
        <header id="header" className={`full-header border-full-header header-size-custom ${isScrolled ? 'sticky-header' : 'transparent-header'} ${isMobileMenuOpen ? 'primary-menu-open' : ''}`}
                data-sticky-shrink="false">
            <div id="header-wrap" className={isScrolled ? 'sticky-header-shrink' : ''}>
                <div className="container">
                    <div className="header-row">

                        <div id="logo">
                            <Link to="/">
                                <img className="logo-default" srcSet="/ata-logo.png, /ata-logo@2x.png 2x"
                                     src="/ata-logo@2x.png" alt="AT Architects Logo"/>
                                <img className="logo-dark" srcSet="/ata-logo-dark.png, /ata-logo@2x.png 2x"
                                     src="/ata-logo-dark@2x.png" alt="AT Architects Logo"/>
                            </Link>
                        </div>

                        <div className={`primary-menu-trigger ${isMobileMenuOpen ? 'primary-menu-trigger-active' : ''}`}>
                            <button
                                className={`cnvs-hamburger ${isMobileMenuOpen ? 'active' : ''}`}
                                type="button"
                                title="Open Mobile Menu"
                                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                            >
                                <span className="cnvs-hamburger-box"><span className="cnvs-hamburger-inner"></span></span>
                            </button>
                        </div>


                        <nav className={`primary-menu ${isMobileMenuOpen ? 'primary-menu-active' : ''}`}>
                            <ul className="one-page-menu menu-container" data-easing="easeInOutExpo" data-speed="1250"
                                data-offset="65">
                                {menuItems.map((item) => (
                                    <li key={item.path} className="menu-item">
                                        <Link
                                            to={item.path}
                                            className={`menu-link ${
                                                location.pathname === item.path ? 'active' : ''
                                            }`}
                                        >
                                            {item.label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </nav>

                    </div>
                </div>
            </div>
            <div className="header-wrap-clone"></div>
        </header>
);
};

export default Header;